




































































































































































import constants from '@/utils/constants';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class ConfirmAtionBox extends Vue {
  @Prop() isBillBarActive!: boolean;
  @Prop() nextStatusValue!: any;
  @Prop() isUpdateOrderStatus!: boolean;
  @Prop() isCancelOrder!: boolean;
  @Prop() isRefundOrder!: boolean;
  @Prop({ default: constants.ARE_YOU_SURE }) title?: string;
  @Prop() orderItem!: any;
  @Prop() refund!: Function;
  @Prop() isNextModalShow!: boolean;
  @Prop() isChangeBillStatus!: boolean;
  @Prop() paymentMethod!: string;
  @Prop() isOverRide!: boolean;
  @Prop() outletCode!: string;
  @Prop(Function) cancel!: Function;
  @Prop(Function) confirm!: Function;
  @Prop(Function) reject!: Function;
  @Prop(Function) cancelBill!: Function;
  @Prop(Function) changeBillStatusPayCashier!: Function;
  @Prop(Function) showNextModal!: Function;
  @Prop(Function) selectPaymentMethod!: Function;
  @Prop() currentBillitem!: any;
  @Prop() cancelItem!: any;
  $swal: any;
  public password: string = '';
  public refundAmount: number = 0;
  public refundReason: string = '';
  public constants: any = constants;
  public isChecking: boolean = false;
  public paymentMethods: object = [
    {
      text: 'Debit Card',
      value: 'DEBITCARD',
      icon: require('@/assets/cc.png')
    },
    {
      text: 'Credit Card',
      value: 'CREDITCARD',
      icon: require('@/assets/card.png')
    },
    {
      text: 'QRIS Payment',
      value: 'QR',
      icon: require('@/assets/qr-icon.png')
    },
    {
      text: 'Pay Cash',
      value: 'cash',
      icon: require('@/assets/bt.png')
    }
  ];
  mounted() {
    this.password = '';
  }
  async handleReject() {
    if (this.isCancelOrder) {
      if (!this.password) {
        return this.$swal(
          constants.SOMETHING_WROING,
          this.voidValidate ? 'Please input the PIN' : 'Please input the code',
          constants.STATUS_ERROR
        );
      }
      if (this.voidValidate) {
        try {
          this.isChecking = true;
          const response: any = await this.$store.dispatch('CheckStorePin', {
            outletCode: this.cancelItem.outletCode || this.currentBillitem.outlet_code,
            pinCode: this.password,
          });
          if (!response.data.validate) {
            return this.$swal(
              constants.SOMETHING_WROING,
              'Invalid PIN',
              constants.STATUS_ERROR
            );
          }
        } catch (error) {
          return this.$swal(
            constants.SOMETHING_WROING,
            error,
            constants.STATUS_ERROR
          )
        } finally {
          this.isChecking = false;
        }
      } else {
        if (
          (this.cancelItem.outletCode || this.currentBillitem.outlet_code) !==
          this.password
        ) {
          return this.$swal(
            constants.SOMETHING_WROING,
            'Please input the correct code',
            constants.STATUS_ERROR
          );
        }
      }
      this.reject(this.voidValidate ? this.password : undefined);
    } else if (this.isRefundOrder) {
      if (!this.refundAmount) {
        return this.$swal(
          constants.SOMETHING_WROING,
          'Please input the amount',
          constants.STATUS_ERROR
        );
      }
      if (this.refundAmount > this.orderItem.totalSales) {
        return this.$swal(
          constants.SOMETHING_WROING,
          'The refund amount cannot exceed the total amount',
          constants.STATUS_ERROR
        );
      }
      this.refund(this.refundAmount, this.refundReason);
    } else {
      this.reject();
    }
  }
  get voidValidate() {
    if (this.isBillBarActive) {
      return this.currentBillitem.voidValidate;
    } else {
      return this.cancelItem.voidValidate;
    }
  }
}
